const state = {
    position: {x: 0, y: 0},
    clickPosition: {x: 0, y: 0},
};

const getters = {
    position: state => {
        return state.position;
    }
};

const actions = {
    updateMousePosition({ commit }, val) {
        commit('UPDATE_MOUSE_POSITION', val)
    },
    updateMouseClickPosition({ commit }, val) {
        commit('UPDATE_MOUSE_CLICK_POSITION', val)
    },
};

const mutations = {
    // update current mouse position on ii and panorama
    UPDATE_MOUSE_POSITION(state,val){
        state.position = val
    },
    UPDATE_MOUSE_CLICK_POSITION(state,val){
        state.clickPosition = val
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
